
export default function ToolkitHero() {
  return (
    <section
      className="relative min-h-[340px] flex items-center overflow-hidden"
      style={{
        background:
          "linear-gradient(135deg, #1a1a2e 0%, #16213e 40%, #0f3460 70%, #533483 100%)",
      }}
    >
      {/* Decorative gradient orbs */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-gradient-to-bl from-pink-500/20 to-transparent rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-1/4 w-72 h-72 bg-gradient-to-tr from-blue-500/15 to-transparent rounded-full blur-3xl"></div>

      <div className="container mx-auto px-4 relative z-10 py-16">
        <div className="max-w-2xl">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4 leading-tight">
            One link.<br />All the toolkits.
          </h1>
          <p className="text-lg text-gray-300">
            All the resources you need to power your real estate business in one convenient spot.
          </p>
        </div>
      </div>
    </section>
  );
}
